import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';

export function AdminLogin() {
  const { login } = useAdminAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);

    const success = login(username, password);
    if (success) {
      nav('/admin');
    } else {
      setError('Credenciais inválidas. Use admin/admin');
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 px-4">
      <div className="w-full max-w-md">
        <div className="panel p-8">
          <div className="text-center mb-6">
            <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-red-500 to-red-700 flex items-center justify-center mx-auto mb-4">
              <i className="fa-solid fa-shield-halved text-white text-2xl"></i>
            </div>
            <h1 className="text-2xl font-bold heading mb-2">Admin Login</h1>
            <p className="text-sm opacity-70">Área restrita - CopyGenius</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2">Usuário</label>
              <input
                className="input w-full"
                value={username}
                onChange={e => setUsername(e.target.value)}
                type="text"
                placeholder="admin"
                required
                autoComplete="username"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Senha</label>
              <input
                className="input w-full"
                value={password}
                onChange={e => setPassword(e.target.value)}
                type="password"
                placeholder="••••••••"
                required
                autoComplete="current-password"
              />
            </div>

            {error && (
              <div className="panel-alt p-3 flex items-start gap-2 text-sm" style={{ background: 'var(--cg-danger-bg)', borderColor: 'var(--cg-danger)' }}>
                <i className="fa-solid fa-triangle-exclamation mt-0.5" style={{ color: 'var(--cg-danger)' }}></i>
                <span style={{ color: 'var(--cg-danger)' }}>{error}</span>
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary w-full h-12 text-base"
            >
              <i className="fa-solid fa-right-to-bracket"></i> Entrar
            </button>
          </form>

          <div className="mt-6 text-center text-xs opacity-60">
            <p>Credenciais: admin / admin</p>
          </div>
        </div>
      </div>
    </div>
  );
}
